export default __webpack_public_path__ + "static/images/1098478432a1d6e5db7eff54de5c5916.png";